import React from 'react';
import { Zap, Trash2 } from 'lucide-react';
import { useWorkbenchContext } from '../../app/GameProviders';

export function WorkbenchHeader() {
  const { workbenchMaterials, clearWorkbench } = useWorkbenchContext();

  return (
    <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-30 flex items-center gap-4">
      <div className="flex items-center gap-2 bg-slate-800/50 backdrop-blur rounded-lg px-4 py-2">
        <Zap className="w-5 h-5 text-yellow-400" />
        <span className="text-lg font-semibold">Kitchen</span>
      </div>
      {workbenchMaterials.length > 0 && (
        <button
          onClick={clearWorkbench}
          className="text-slate-400 hover:text-white flex items-center gap-2 text-sm bg-slate-700/50 px-3 py-2 rounded-md transition-colors"
        >
          <Trash2 className="w-4 h-4" /> Clear
        </button>
      )}
    </div>
  );
}
